<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Menu.AddCustomerMenu')"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    width="600px"
  >
    <el-form label-width="40px" label-position="left" inline>
      <el-form-item :label="$t('Menu.Search')">
        <cargo-advance-select
          ref="tenantSel"
          :select-type="selectTypeNames.TENANT"
          :cache="false"
          filterable
          :custom-label="companyLabel"
          :callback-params="{key:'relateTenantId'}"
          callback-method-type="value"
          :default-value="String(txtSearch)||''"
          style="width:200px"
          @parentCallBack="tenantIdChangeHandler"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="removeSelectEvent">{{ $t('Menu.Removed') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <div slot="footer">
      <el-button type="primary" @click="enterHandler">{{ $t('Menu.OK') }}</el-button>
      <el-button type="primary" @click="closeHandler">{{ $t('Menu.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import * as sysMenuApi from '@/api/menu'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'SysMenuByAddTenantWindow',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    menus: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false,
      txtSearch: '',
      selectTypeNames: TYPE_NAMES,
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Menu.Numbering'),
          field: 'tenantId',
          width: 200
        },
        {
          headerName: this.$t('Menu.CompanyChineseName'),
          field: 'name',
          width: 200
        }
      ],
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.rowData = []
        this.txtSearch = ''
      }
    }
  },
  methods: {
    companyLabel(data) {
      if (data) {
        return '[' + data.id + ']' + data.name
      }
      return ''
    },
    tenantIdChangeHandler(item) {
      this.txtSearch = item.value
      if (this.txtSearch) {
        const tenant = this.$refs.tenantSel.options.find(el => el.id === this.txtSearch)
        const index = this.rowData.findIndex(row => row.tenantId === tenant.id)
        if (tenant && index === -1) {
          tenant.tenantId = tenant.id
          this.rowData.push(tenant)
        }
      }
    },
    removeSelectEvent() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const clickRow = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!clickRow) {
        this.$message.warning(this.$t('Menu.PleaseSelectTheCustomer'))
        return
      }
      const index = this.rowData.findIndex(row => row === clickRow)
      if (index > -1) {
        this.rowData.splice(index, 1)
      }
    },
    enterHandler() {
      if (this.rowData.length === 0) {
        this.$message.warning(this.$t('Menu.NoCustomersWantToAdd'))
        return
      }
      const tenantKeys = []
      const menuKeys = []
      for (const t of this.rowData) {
        tenantKeys.push(t.uuid)
      }
      for (const m of this.menus) {
        menuKeys.push(m.uuid)
      }
      const item = {}
      item.menuKeys = menuKeys
      item.tenantKeys = tenantKeys
      const loading = getLoading()
      sysMenuApi.addTenantMenus(item).then(resp => {
        this.$message.success(this.$t('Menu.SavedSuccess'))
        this.closeHandler()
      }).finally(() => loading.close())
    },
    closeHandler() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
